<template>
  <section class="module-restricted">
    <div class="card shadow-sm border-0">
      <div class="card-body text-center py-5">
        <div class="icon-wrapper mb-4">
          <i class="bi bi-lock-fill"></i>
        </div>
        <h1 class="h3 mb-3">Módulo no disponible</h1>
        <p class="text-muted mb-4">
          {{ message }}
        </p>
        <div class="d-flex justify-content-center gap-3 flex-wrap">
          <router-link class="btn btn-primary" to="/">
            Volver al inicio
          </router-link>
          <button class="btn btn-outline-secondary" type="button" @click="goBack">
            Regresar
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ModuleRestricted',
  computed: {
    moduleCode() {
      return this.$route.query?.module || '';
    },
    message() {
      if (!this.moduleCode) {
        return 'No tienes acceso a esta sección. Contacta al administrador para habilitar el módulo.';
      }
      return `Tu plan actual no incluye el módulo "${this.moduleCode}". Contacta al administrador para habilitarlo.`;
    }
  },
  methods: {
    goBack() {
      if (window.history.length > 1) {
        this.$router.back();
      } else {
        this.$router.replace('/');
      }
    }
  }
};
</script>

<style>
.module-restricted {
  max-width: 620px;
  margin: 60px auto;
}

.icon-wrapper {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(17, 115, 212, 0.12);
  color: #1173d4;
  font-size: 36px;
}

.dark-theme .card {
  background-color: #172133;
  color: #f8fafc;
}

.dark-theme .text-muted {
  color: #cbd5f5 !important;
}
</style>
